import { Badge } from "antd"

//checks if there is data to display, if there is, displays a badge
export const isThereBadge = (data, label, key, icon, children) => {
  if (data > 0) {
    return {
      label: (
        <Badge count={data} offset={[10, 0]} overflowCount={999}>
          <span>{label}</span>
        </Badge>
      ),
      key: key,
      icon: icon,
      children: children,
    }
  } else {
    return {
      label: label,
      key: key,
      icon: icon,
      children: children,
    }
  }
}

export const getItem = (label, key, icon, children) => {
  return {
    label: label,
    key: key,
    icon: icon,
    children: children,
    title: null,
  }
}
